import { useState, useContext, useEffect } from 'react'
import { SceneContext } from './SceneContext'
import './css/MiniPlayer.css'

export default function MiniPlayer(props) {

    const [state, setState] = useState({
        audio_player: new Audio('audios/' + (props.data.src || 'test.mp3') ),
        progress_pct: 0
    })

    const [canPlay, setCanPlay] = useState(false)

    const context = useContext(SceneContext)

    useEffect(() => {
        state.audio_player.pause()
        state.audio_player.src = 'audios/' + (props.data.src || 'test.mp3')
        state.audio_player.preload = "auto"
        state.audio_player.load()
        setState( s => ({...s, progress_pct: 0}) )
    }, [props.data.src, state.audio_player])

    useEffect(() => {
        state.audio_player.ontimeupdate = (() => progress_bar_update(state, setState, context))
        state.audio_player.onended = (() => context.deactivateAudioBox(props.index))
    }, [props.index])

    useEffect(() => {
        state.audio_player.preload = "auto"
        state.audio_player.addEventListener('canplay', () => {
            setCanPlay(true)
        })
    }, [])

    useEffect(()=>{
        play_stop_audio(props, state, context, canPlay)
    }, [canPlay])

    useEffect(() => {
        play_stop_audio(props, state, context, canPlay)
        return (() => {
            state.audio_player.pause()
            //state.audio_player.currentTime = 0
        })
    }, [context.audioboxes_state, context.dev_mode])

    return (
        <div>
            <div index={ 'audioBox-' + props.index + '-a' }
                className={ 'mini-player selectable' }
                style={ compute_style(props, state, context) } 
                onMouseEnter={() => context.activateAudioBox(props.index)}
                onClick={ (e) => { !context.dev_mode ? trackAudio(e, state) : context.setMoveableElement(e) } }>
                
                <div className={'pg-bar'} style={{ width: state.progress_pct+'%' }}>
                    {/*<img className={'pg-img'} src={'images/audio.png'} draggable={"false"} alt=""></img>*/}
                </div>

                {/* !canPlay? <img className={'loading-audio'} src={'images/loading-small.gif'} draggable={"false"} alt=""></img> : '' */}
            </div>
            
            { !canPlay? <img style={{ top: props.data.y-4 || 0, left: props.data.x-20 || 0, opacity: context.dev_mode? 1 : (context.audioboxes_state[props.index]? 1 : 0)}} className={'loading-audio'} src={'images/loading-small.gif'} draggable={"false"} alt=""></img> : '' }

        </div>
    )

}

function trackAudio(e, state) {
    if(e.target.classList.contains('pg-img')) {
        e.preventDefault()
        return
    }

    let clicked_x = e.nativeEvent.offsetX
    let bar_width = e.target.classList.contains('pg-bar')? e.target.offsetParent.scrollWidth : e.target.scrollWidth
    let pct = clicked_x/bar_width
    let max_audio_time  = state.audio_player.duration
    let selected_time  = max_audio_time * pct

    state.audio_player.currentTime = selected_time
}

function play_stop_audio(props, state, context, canPlay) {
    let active = context.audioboxes_state[props.index]
    if (context.dev_mode === false) {
        if(active && canPlay) {
            state.audio_player.play()
        } else {
            state.audio_player.pause()
            //state.audio_player.currentTime = 0
        }
    } else {
        state.audio_player.pause()
    }
    return active
}

function compute_style(props, state, context) {
    let is_active = context.audioboxes_state[props.index]

    const style = { 
        top: props.data.y || 0, 
        left: props.data.x || 0, 
        /*border: context.dev_mode? ('1px solid ' + props.color) : ('1px solid rgba(0,0,0,1)'),*/
        opacity: context.dev_mode? 1 : (is_active? 1 : 0) 
    }

    return style 
}

function progress_bar_update(state, setState, context){
    let current_time = state.audio_player.currentTime
    let max_time     = state.audio_player.duration
    let pct = current_time/max_time * 100

    setState( s => ({...s, progress_pct: pct}) )
}